import { GraphQLResult } from "@aws-amplify/api-graphql";
import { API, Auth } from "aws-amplify";
import { v4 as uuidv4 } from 'uuid';
import getConfig from "../aws-exports/index";
import { doLogin } from "../store/actions/userActions";
import { Env, NO_CURRENT_USER } from "../utils/constants";

const awsExports: any = getConfig(process.env.REACT_APP_ENV as Env);

// auth: {
//     type: awsExports.aws_appsync_authenticationType,
//     jwtToken: async () => (await Auth.currentSession()).getIdToken().getJwtToken()
// }



export const executeGraphqlQuery = async (query: any, variables?: any) => {
    try {
        let options: any = {
            query: query
        }
        if (variables) {
            options = {
                ...options,
                variables: { input: variables }
            }
        }
        // const cognitoUser = await Auth.currentAuthenticatedUser();
        // cognitoUser.refreshSession(getUserToken, (err: any, session: any) => {
        //     setSessionCookieData({
        //       userToken: session?.idToken?.jwtToken,
        //       refreshToken: session?.refreshToken?.token,
        //     });
        //   });
        return await API.graphql(options, { 'x-correlation-id': uuidv4() });
    } catch (error: any) {
        if (error && error?.message?.includes(NO_CURRENT_USER)) {
            doLogin()
        }
        else {
            throw error.errors[0] || error;
        }
    }
}

export const executeGraphqlMutation = async (query: any, variables: any) => {
    try {
        return await API.graphql({ query: query, variables: { input: variables } }, { 'x-correlation-id': uuidv4() })
    } catch (error: any) {
        if (error && error?.message?.includes(NO_CURRENT_USER)) {
            doLogin();
        }
        else {
            throw error.errors[0] || error;
        }
    }
}

export const executeGraphqlSubscribe = (query: any, variables: any = {}): any => {
    return API.graphql({ query: query, variables: variables });
}


const retryAPIcalls = async (options: any, retries = 2): Promise<any> => {
    try {
        return await API.graphql(options);
    } catch (error: any) {
        if (retries !== 0 && error && error?.message?.includes(NO_CURRENT_USER)) {
            return Auth.currentSession()
                .then((res) => {
                    console.log(res)
                    return retryAPIcalls(options, --retries)
                })
                .catch(err => console.log(err))
        } else {
            return Promise.reject(error);
        }
    }
}